export const paths = {
  home: "/",
  auth: {
    personal: {
      signIn: "/sign-in",
      signUp: "/sign-up",
      forgotPassword: "/forgot-password",
      resetPassword: "/reset-password",
      verifyCode: "/verify-code",
      createNewPassword: "/create-new-password",
    },
    business: {
      signIn: "/business/sign-in",
      signUp: "/business/sign-up",
      signOut: "/business/sign-out",
      forgotPassword: "/business/forgot-password",
      verifyCode: "/business/verify-code",
      createNewPassword: "/business/create-new-password",
    },
  },
  products: "/products",
  services: "/services",
  faq: "/faq",
  contactUs: "/contactus",
  termscondition: "/terms",
  aboutUs: "/aboutus",
  privacypolicy: "/privacypolicy",
  accountsetting: "/accountsetting",
  orders: "/orders",
  aboutUs: "/aboutus",
};
export const serverErroMessageMapper = {
  invalid_credential: "Invalid user credentials",
  wrong_user: "INVALID_USER_TYPE",
  unverified_user: "You must verify your email before login",
  user_exists: "User already exists",
};
